import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./BecomeMember.css";

import groupPhoto from "../../Assets/images/ugaal.png";
import ugaaLogo from "../../Assets/images/logo-rmbg.png";

export default function BecomeMember() {
  const navigate = useNavigate(); // initialize navigation

  const goToRegistration = () => {
    navigate("/membership/register"); // navigate programmatically
  };

  return (
    <div className="become-member">
      {/* HERO SECTION */}
      <section className="hero-section">
        <img src={groupPhoto} alt="UGAA Liberia Members" className="hero-bg" />
        <div className="hero-overlay" />

        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img src={ugaaLogo} alt="UGAA Liberia Logo" className="hero-logo" />
          <h1>Become a Member of UGAA Liberia</h1>
          <p>
            Join a united body of University of Ghana alumni and former students
            committed to friendship, professional excellence, and national
            development.
          </p>
          <button onClick={goToRegistration} className="primary-btn">
            Proceed to Registration
          </button>
        </motion.div>
      </section>

      {/* WHO CAN JOIN */}
      <section className="section">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          Who Can Join
        </motion.h2>

        <div className="card-grid">
          {["Graduates", "Former Students", "Liberia & Diaspora"].map(
            (title, index) => (
              <motion.div
                key={index}
                className="info-card"
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <h3>{title}</h3>
                <p>
                  {title === "Graduates" &&
                    "Graduates of the University of Ghana."}
                  {title === "Former Students" &&
                    "Former students of UG and affiliate institutions such as GIMPA, UPSA, Wisconsin and others."}
                  {title === "Liberia & Diaspora" &&
                    "Alumni residing in Liberia and abroad, irrespective of nationality."}
                </p>
              </motion.div>
            )
          )}
        </div>
      </section>

      {/* AIMS & OBJECTIVES */}
      <section className="section alt-bg">
        <h2>Our Aims & Objectives</h2>
        <div className="two-col">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h3>Unity, Networking & Fellowship</h3>
            <p>
              Promote unity, networking and fellowship among members, strengthening bonds
              of friendship and creating a united community for social and economic
              wellbeing.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h3>Professional & Intellectual Growth</h3>
            <p>
              Encourage intellectual, professional development, research and
              educational programs for national growth.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h3>Welfare & Solidarity</h3>
            <p>
              Provide moral, social and economic support to members during
              significant life events.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            <h3>National & Bilateral Development</h3>
            <p>
              Promote cooperation between Liberia and Ghana while projecting the
              image of the University of Ghana.
            </p>
          </motion.div>
        </div>
      </section>

      {/* MEMBERSHIP & DUES */}
      <section className="section">
        <h2>Membership & Responsibilities</h2>
        <div className="two-col">
          <div>
            <h3>Member Benefits</h3>
            <ul>
              <li>Participation in alumni events</li>
              <li>Professional networking</li>
              <li>Welfare and solidarity support</li>
              <li>Community development contribution</li>
              <li>Career Support: Jobs, Internships & Mentorship Opportunities</li>
            </ul>
          </div>

          <div>
            <h3>Responsibilities</h3>
            <ul>
              <li>Abide by constitution and bye-laws</li>
              <li>Respect association values</li>
              <li>Prompt payment of dues</li>
              <li>Promote UGAA objectives</li>
            </ul>
          </div>
        </div>

        <motion.div
          className="cta-box"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <p>
            <strong>Monthly Due:</strong> USD 5.00 per member
          </p>
          <button onClick={goToRegistration} className="secondary-btn">
            Register as a Member
          </button>
        </motion.div>
      </section>
    </div>
  );
}
